var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "p-l-10 p-r-10 p-t-5 p-b-5" },
    [
      _vm.hasTranscription
        ? [
            _vm.isLoadingTranscription
              ? _c(
                  "div",
                  {
                    staticClass: "ag-custom-loading-cell p-l-15 p-t-5",
                    staticStyle: { "line-height": "25px" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-spinner fa-pulse fa-fw" }),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "TRANSCRIPTION_LOADING",
                          expression: "'TRANSCRIPTION_LOADING'"
                        }
                      ]
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.transcriptionError
              ? _c(
                  "div",
                  { staticClass: "bs-callout bs-callout-sm bs-callout-danger" },
                  [_c("p", [_vm._v(_vm._s(_vm.$t("TRANSCRIPTION_ERROR")))])]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.transcriptionSuccess
              ? _c(
                  "table",
                  {
                    staticClass:
                      "table_basic call-log-sub-table-record condensed"
                  },
                  [
                    _c("tbody", [
                      _c("tr", [
                        _c("th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "TRANSCRIPT_COST",
                              expression: "'TRANSCRIPT_COST'"
                            }
                          ],
                          attrs: { scope: "row" }
                        }),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.callDetails.transcriptionCost
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "TRANSCRIPTION",
                              expression: "'TRANSCRIPTION'"
                            }
                          ],
                          attrs: { scope: "row" }
                        }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "clipboard",
                                  rawName: "v-clipboard",
                                  value: {
                                    copyText: _vm.transcriptionCopyText
                                  },
                                  expression:
                                    "{ copyText: transcriptionCopyText }"
                                }
                              ],
                              staticClass:
                                "clickable display-flex flex--align-center"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("COPY_TRANSCRIPT")) +
                                  "\n              "
                              ),
                              _vm._m(0)
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "transcript-row" }, [
                        _c("td", { attrs: { colspan: "2" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "transcript",
                              class: {
                                "transcript--empty": _vm.isEmptyTranscript
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "transcript__content" },
                                [
                                  _vm.isEmptyTranscript
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("TRANSCRIPTION_EMPTY")
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    : _vm._l(
                                        _vm.transcription.utterances,
                                        function(utterance, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "transcript__utterance"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "transcript__time"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.formatSeconds(
                                                          utterance.start
                                                        )
                                                      ) +
                                                      " - \n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              utterance.channel === 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "transcript__channel transcript__channel--alt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "TRANSCRIPTION_CALLER"
                                                            )
                                                          ) +
                                                          ":\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "transcript__channel"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "TRANSCRIPTION_TARGET"
                                                            )
                                                          ) +
                                                          ":\n                    "
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(utterance.transcript)
                                                )
                                              ])
                                            ]
                                          )
                                        }
                                      )
                                ],
                                2
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ]
        : _c(
            "div",
            { staticClass: "p-15" },
            [
              _vm.isTranscriptionPending || _vm.sentTranscriptionRequest
                ? [
                    _c("p", { staticClass: "m-b-15" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("TRANSCRIPTION_PENDING")) +
                          "\n      "
                      )
                    ])
                  ]
                : [
                    _c("p", { staticClass: "m-b-15" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("TRANSCRIPTION_AVAILABLE")) +
                          "\n      "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-loader p-l-15",
                        class: _vm.isTranscribing ? "p-r-35" : "p-r-15",
                        attrs: { disabled: _vm.isTranscribing },
                        on: { click: _vm.transcribeCall }
                      },
                      [
                        _c("i", { staticClass: "fa fa-file-text-o" }),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("TRANSCRIBE")) +
                            " \n        "
                        ),
                        _vm.isTranscribing
                          ? _c("Loader", {
                              attrs: { "custom-class": "size-sm" }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
            ],
            2
          )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("button", { staticClass: "btn btn-link m-l-5 p-0 no_border" }, [
      _c("i", { staticClass: "typcn typcn-tabs-outline" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }